import React, { ReactNode } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setForm } from "../reducers/formslice";

interface IProps {
  caption?: string;
  title: string;
  buttonText: string;
  extraButton?: ReactNode;
}

function GeneralClosing({ caption, title, buttonText, extraButton }: IProps) {
  const dispatch = useDispatch();

  return (
    <div className="my-4 py-4">
      <Row className="justify-content-center">
        <Col xl={9} lg={10} md={10} sm={12}>
          {caption && (
            <div className="mb-2 text-size-body-head text-secondary text-center">
              {caption}
            </div>
          )}

          <div className="mb-5 text-size-title-2 fw-extra-bold text-primary-main text-center">
            {title}
          </div>
          <div className="d-flex justify-content-center">
            <Button
              variant="primary"
              size="lg"
              onClick={() => dispatch(setForm("register"))}
            >
              {buttonText}
            </Button>
            {extraButton}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default GeneralClosing;
